export default "__VITE_ASSET__DHNwNv64__"